import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { lineClamp } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import FakeButtonStyles from '@stories/Components/Buttons/FakeButton/FakeButton.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled, { css } from 'styled-components';
const Container = styled.article `
  ${({ variant }) => {
    switch (variant) {
        case 'supporterCardFull':
            return css `
          ${setCssVar('bgColor', brand.hta.greenLight)};
          ${setCssVar('fgColorAlt', brand.hta.green)};
        `;
        case 'supporterCardProvisional':
            return css `
          ${setCssVar('bgColor', brand.greyVeryLight)};
          ${setCssVar('fgColorAlt', brand.grey)};
        `;
        default:
            return css `
          ${setCssVar('bgColor', brand.greyVeryLight)};
          ${setCssVar('fgColorAlt', brand.grey)};

          @media ${from(Device.Tablet)} {
            min-height: 387px;
          }
        `;
    }
}}

  ${setCssVar('accentColor', brand.hta.greenAlt)};
  ${setCssVar('fgColor', brand.black)};

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.greenAlt)};
  }

  display: flex;
  background: ${cssVar('bgColor')};
  border-radius: 11px;
  color: ${cssVar('fgColor')};
  height: 100%;
  text-decoration: none;
  transition: background-color 0.15s ease-out;

  @media ${until(Device.Tablet)} {
    flex-direction: column;
  }

  @media ${from(Device.Tablet)} {
    flex-direction: column;
  }
`;
const ContentWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: flex-start;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 10px 20px 10px 10px;

  ${FakeButtonStyles.Button} {
    margin-top: auto;
  }

  @media ${from(Device.Tablet)} {
    padding: 32px;
  }
`;
const TitleLink = styled.a `
  color: ${cssVar('fgColor')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
const Title = styled.h3 `
  ${lineClamp(3, 'inline')};

  @media ${until(Device.Tablet)} {
    ${fonts.sourceSansPro.semiBold};
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 16px;

    @media ${from(Device.Tablet)} {
      font-size: 22px;
      line-height: 32px;
    }

    @media ${from(Device.Desktop)} {
      font-size: 25px;
      line-height: 35px;
    }

    @media ${from(Device.DesktopLarge)} {
      font-size: 30px;
      line-height: 38px;
    }
  }

  @media ${from(Device.Tablet)} {
    ${fonts.sourceSansPro.semiBold};
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 16px;

    @media ${from(Device.Tablet)} {
      font-size: 22px;
      line-height: 32px;
    }

    @media ${from(Device.Desktop)} {
      font-size: 25px;
      line-height: 35px;
    }

    @media ${from(Device.DesktopLarge)} {
      font-size: 30px;
      line-height: 38px;
    }
  }
`;
const Content = styled.p `
  ${ParagraphStyles.SmallStyles};
  margin: 0;
`;
const DetailItem = styled.span `
  display: flex;
  align-items: flex-start;
  color: currentColor;
  margin: 0 0 22px;
  text-decoration: none;
  width: 100%;

  a& {
    &:focus,
    &:hover {
      text-decoration: underline;
      text-underline-position: under;
    }
  }
`;
const DetailIcon = styled.span `
  display: block;
  color: ${cssVar('accentColor')};
  height: 24px;
  margin: 0 12px 0 0;
  width: 24px;
  flex: 0 0 30px;
`;
const DetailBlock = styled.div `
  display: block;
  margin: auto 0 -22px;
`;
const DetailHeading = styled.span `
  display: block;
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 28px;
  margin-bottom: -8px;
`;
const DetailText = styled.span `
  display: block;
  ${fonts.sourceSansPro.regular};
  font-size: 18px;
  line-height: 28px;
`;
const Separator = styled.hr `
  display: block;
  border: 0;
  border-bottom: 1px solid ${cssVar('fgColorAlt')};
  margin: 18px 0;
  opacity: 0.3;
  width: 100%;
`;
const TagList = styled.ul `
  display: block;
  margin: 0 -9px;
`;
const TagItem = styled.li `
  display: inline-block;
  ${fonts.sourceSansPro.regular};
  font-size: 14px;
  line-height: 20px;
  padding: 0 9px 8px;
`;
const ButtonContainer = styled.div `
  margin-top: 18px;
`;
const SustainabilityHeader = styled.div `
  display: block;
  width: 100%;
  ${fonts.sourceSansPro.regular};
  text-transform: uppercase;
  font-size: 16px;
  line-height: 18px;
  padding: 0 58px 8px 0;
  margin: 8px 0 20px;
  border-bottom: 1px solid ${cssVar('fgColorAlt')};

  @media ${from(Device.Tablet)} {
    margin: -12px 0 28px;
    padding-right: 56px;
  }
`;
const SustainabilityBadge = styled.span `
  display: block;
  position: absolute;
  top: 0;
  right: 12px;
  width: 58px;
  height: 58px;
  padding: 3px;
  background-color: ${cssVar('fgColorAlt')};
  border-radius: 0 0 12px 12px;

  @media ${from(Device.Tablet)} {
    right: 16px;
    width: 66px;
    height: 66px;
    padding: 6px;
  }

  @media ${from(Device.DesktopLarge)} {
    right: 32px;
  }
`;
export default {
    Container,
    Content,
    ContentWrapper,
    DetailIcon,
    DetailItem,
    DetailBlock,
    DetailHeading,
    DetailText,
    Separator,
    TagItem,
    TagList,
    Title,
    TitleLink,
    ButtonContainer,
    SustainabilityHeader,
    SustainabilityBadge,
};
